import { Testimonial } from "../types/testimonial";

export const testimonials: Testimonial[] = [
  {
    id: "1",
    author: "Marcus Reinhart",
    role: "Principal",
    company: "Alpine Capital Partners",
    quote:
      "Hotel Foundry transformed our underwriting process. What used to take weeks in Excel now takes hours with their USALI models. The sensitivity analysis alone saved us from a costly mistake in Mallorca.",
  },
  {
    id: "2",
    author: "Isabella Rossi",
    role: "Managing Director",
    company: "Mediterranean Asset Management",
    quote:
      "The benchmark data for Balearic properties is incredibly accurate. Having reliable ADR and cost benchmarks gave us confidence in our €12M Ibiza acquisition. Worth every euro.",
  },
  {
    id: "3",
    author: "James Wellington",
    role: "Investment Director",
    company: "Coastal Hospitality Group",
    quote:
      "The platform's IRR calculations and debt service coverage analysis are institutional-grade. Our investors now receive board-ready presentations straight from the platform.",
  },
];
